import { buildQueryString, fetchWrapper } from '@/_helpers';

export const clientNotesApi = {
    getClientNotes: ({ client, archived } = {}) => {
        const queryString = buildQueryString({
            client,
            archived,
        });
        return fetchWrapper.get(`client-notes?${queryString}`);
    },
    createClientNote: (data) => fetchWrapper.post('client-notes', data),
    updateClientNote: (id, data) => fetchWrapper.put(`client-notes/${id}`, data),
    patchClientNote: (id, data) => fetchWrapper.patch(`client-notes/${id}`, data),
};
